/**
 * Sleep for a specified number of milliseconds
 */
export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

/**
 * Retry a function with a fixed delay between attempts
 *
 * @param fn - The async function to retry
 * @param maxRetries - Maximum number of retry attempts (default: 3)
 * @param delayMs - Delay in milliseconds between retries (default: 500)
 * @returns The result of the function if successful
 * @throws The last error if all retries fail
 */
export const withRetry = async <T>(
  fn: () => Promise<T>,
  maxRetries = 3,
  delayMs = 500,
): Promise<T> => {
  try {
    return await fn();
  } catch (error) {
    if (maxRetries > 0) {
      await sleep(delayMs);
      return withRetry(fn, maxRetries - 1, delayMs);
    }
    throw error;
  }
};
